import React from 'react';
import { Jumbotron, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const HomeCard = ({ name, bgImg, link }) => {
  return (
    <div className='shadow-sm'>
      <Jumbotron
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: 'cover',
        }}
      >
        <div
          className='p-2 rounded'
          style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
        >
          <h2
            className='text-center'
            style={{ color: '#fff', fontWeight: 300 }}
          >
            {name}
          </h2>

          <p className='text-center'>
            <Link to={link}>
              <Button>View More</Button>
            </Link>
          </p>
        </div>
      </Jumbotron>
    </div>
  );
};
